export enum UserRoleEnum {
  tutor = 0, // view learning paths, select/transfer tasks, has students
  taskCreator = 1, // creates tasks
  methodologist = 2, // views all tasks from the task bank with a certain access level, checks/tests created tasks, edits learning paths, has students
  //    coordinator = 3,    // leads methodologists and tutors
  admin = 4, // sees everything, does everything
}

export let allUserRoles = [
  UserRoleEnum.tutor,
  UserRoleEnum.taskCreator,
  UserRoleEnum.methodologist,
  UserRoleEnum.admin,
];

export let isUserRole = (variable: unknown): variable is UserRoleEnum => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "number" &&
    variable in UserRoleEnum
  );
};
